export function canvasWidth(spec) {
  return Number((spec.canvas || {}).width) || 1200;
}

export function canvasHeight(spec) {
  const bottoms = (spec.placements || []).map((p) => p.layout.y + p.layout.h);
  return Math.max(240, ...bottoms) + 24;
}

export function filterDefaults(spec) {
  const values = {};
  (spec.filters || []).forEach((f) => { values[f.name] = f.default ?? ''; });
  return values;
}

export function placeStyle(p) {
  return {
    left: p.layout.x + 'px', top: p.layout.y + 'px',
    width: p.layout.w + 'px', height: p.layout.h + 'px',
    zIndex: p.layout.z || 1,
  };
}

export function stageStyle(spec) {
  const canvas = spec.canvas || {};
  return {
    background: canvas.background || 'transparent',
    padding: (Number(canvas.padding) || 0) + 'px',
  };
}
